module.exports = __webpack_public_path__ + "afb1a2da2f49aa779d8aa05ca26c8455.png";